<template>
  <div class="container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <!-- <div class="left">
          <el-input
            v-model="form.name"
            placeholder="请输入搜索内容"
            style="width: 210px; display: inline-block"
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="search"
            >搜索</el-button
          >
        </div> -->
        <div class="right">
          <el-button
            type="primary"
            style="margin-left: 16px"
            @click="toggleSelection()"
            >全选</el-button
          >
          <el-button
            type="danger"
            style="margin-left: 16px"
            :disabled="multipleSelection.length === 0"
            @click="deleteClick()"
            >删除</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        height="calc(100% - 110px)"
        :header-cell-style="{ background: '#eaeef6' }"
        ref="companyTables"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column prop="username" label="账号名称" align="center">
        </el-table-column>
        <el-table-column prop="department" label="部门名称" align="center">
        </el-table-column>
        <el-table-column prop="company_name" label="所属公司" align="center">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.pageNum"
          :page-size="table.pageSize"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserByRole, deleteUserRole } from '@/api/role'
import { MessageBox } from 'element-ui'
export default {
  props: ['data'],
  data () {
    return {
      form: {
        name: '',
        type: ''
      },
      loading: false,
      table: {
        data: [],
        height: 100,
        pageNum: 1,
        pageSize: 50,
        total: 0
      },
      multipleSelection: []
    }
  },
  watch: {
    data () {
      this.getData()
    }
  },
  mounted () {
    // this.getData()
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
  },
  methods: {
    //查询数据
    getData () {
      let params = {
        roleId: this.data.id,
        pageNum: this.table.pageNum,
        pageSize: this.table.pageSize
      }
      getUserByRole(params).then(da => {
        this.table.data = da.data.content
        this.table.total = da.data.total
      })
    },
    toggleSelection () {
      // this.table.data.forEach(row => {
      if (this.multipleSelection.length === this.table.total) {
        return
      } else {
        this.$refs.companyTables.toggleAllSelection();
        this.multipleSelection = this.table
      }
      // });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    deleteClick () {
      let that = this
      console.log(that.multipleSelection)
      MessageBox.confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = []
        that.multipleSelection.map(item => {
          ids.push(item.id)
        })
        deleteUserRole({ ids: ids.join(',') }).then(res => {

          if (res.code === 0) {
            that.getData()
            that.$message.success('删除成功!')
          } else {
            that.$message.err(res.message)
          }
        })

      }).catch((e) => {
      });
    },
    currentChange () {
      this.getData()
    },
    handleSizeChange (e) {
      this.table.pageNum = 1
      this.table.pageSize = e
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  // padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    // padding: 0 0;
    // padding-bottom: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status-icon {
      position: relative;
      top: 2px;
      display: inline-block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background: #ff4200;
      &.green {
        background: #00ff00;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.equipment-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
